module.exports = __webpack_public_path__ + "img/automat-outlines-single.3e8a748c.png";